// extracted by mini-css-extract-plugin
export default {"tempPopUp":"CatRecommendations-module__tempPopUp--l2DMS","recommendationsWrapper":"CatRecommendations-module__recommendationsWrapper--TtGt0"};